const create = {
  path: 'create',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftAlipay/found/create'], resolve)
}

export default create
